import { SportAbrv } from "@utils/common";

export const HALF_TIME_SPORTS = new Set<string>([
	SportAbrv.SOCCER,
	SportAbrv.HANDBALL,
]);
